import z from "zod";
import type { TFunction } from "i18next";

export function makeSignInSchema(t: TFunction) {
  return z.object({
    email: z.email(t("auth.signIn.emailInvalid")).trim(),
  });
}

export type SignInFormData = z.infer<ReturnType<typeof makeSignInSchema>>;
